import styled from 'styled-components';

export const Container = styled.section`
    background: linear-gradient(21.73deg, #BF1827 -8.23%, #CC2A55 99.31%) no-repeat;
    display: flex;
    height: 100%;
    width: 100%;

    @media (max-width: 768px) {
        display: flex;
        flex-direction: column;
    }
`;


export const DivContactUs = styled.div`
    width: 50%;
    padding: 5rem;

    @media (max-width: 768px) {
        padding: 0;
        width: 100%;

        .texts-div {
            padding: 20px;
            
        }
        
        .options-div {
            margin: 0 !important;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            .container-options-div {
                width: 329px;
                height: 50px;
                justify-content: center;
            }
        }
    }
    
    @media (max-width: 500px) {
        width: 100%;
        
        .texts-div {
            h1 {
                font-size: 1.8em !important;
            }

            p {
                width: 100%;
                font-size: 1em !important;
            }
        }

        .container-options-div {
            width: 329px !important;
            height: 50px;
            justify-content: center;
        }
        
    }

    @media (max-width: 360px) {
        .container-options-div {
            width: 288px !important;
            height: 50px;
            justify-content: center;
            svg {
                display: none;
            }
        }
    }

    @media (max-width: 320px) {
        .container-options-div {
            width: 256px !important;
        }
    }
    
    .texts-div {
        font-family: Poppins;
        
        h1 {
            font-style: normal;
            font-weight: bold;
            font-size: 3em;
            line-height: 36px;
            color: #ffffff;
        }

        .container-p {
            
            p {
                font-family: Poppins;
                font-style: normal;
                font-size: 1.3rem;
                line-height: 36px;
                color: rgba(255, 255, 255, 0.8);
                /* width: 65%; */
            }
        }

    }

    .options-div {
        display: flex;
        flex-direction: column;
        gap: 2rem;
        margin: 15rem 0;
        
        
        .container-options-div {
            display: flex;
            align-items: center;
            gap: 20px;
            padding: 20px 15px;
            border: 1px solid transparent;
            width: 379px;
            justify-content: flex-start;
            
            svg {
                font-size: 2em;
                color:  #EBDD94;
            }
            
            span, a {
                font-family: Poppins;
                font-style: normal;
                font-weight: 100;
                font-size: 20px;
                line-height: 36px;
                color: #ffffff;
                text-decoration: none;
            }

        }

        #whatsapp-div {
            background-color: #128c7e;
            border-radius: 10px;
            
            a {
                font-size: 17px;
            }
        }

        #whatsapp-div:hover {
            border: 1px solid #6b7267;
            background-color: #6b7267;
        }

        
        .container-options-div:hover {
            border: 1px solid #EBDD94;
            border-radius: 10px;
            cursor: pointer;
        }
    }
`;

export const DivForms = styled.div`
    display: flex;
    justify-content: center;
    width: 50%;
    align-items: center;

    @media (max-width: 768px) {
        width: 100vw;
        margin-bottom: 10px;
        margin-top: 4rem;
        
        .wrapper-content-div {
            height: 90% !important;
            padding: 10px;
            padding: 20px;
            padding-bottom: 35px !important;
        }
    }

    @media (max-width: 420px) {
        margin-bottom: 10px;
        form {
            width: 80% !important;
        }
    }
    
    form {
        display: flex;
        background-color: #fff;
        border: 1px solid #ffffff !important;
        border-radius: 10px;
        flex-direction: column;
        //gap: 3rem;
        padding: 0.8rem;
        width: 100%;
        width: 60%;
        height: 70%;
        justify-content: center;
        
        .div-text-area {
            display: flex;
            flex-direction: column;

            span {
                color: #575F6E;
                font-family: Roboto;
                font-style: normal;
                font-weight: normal;
                font-size: 16px;
                margin-left: 10px;
            }

            .text-area-contact {
                resize: none;
                margin-top: 0;
                min-height: 6rem;
            }
        }


        .button-contact {
            margin: 0 auto;
            background: #1B98E0;
            color: #fff;
        }
    }

`;          